<template>
  <div class="table-container">
    <TableCommon
      title="字典数据"
      :checkbox-config="{ highlight: true }"
      :radio-config="{ highlight: true }"
      :custome-config="() => vxeShowCustom('xTable')"
    >
      <template #button>
        <table-button v-if="mode=== 'add'" name="add" tip="新建" @click="addRow" />
        <table-button v-if="mode=== 'add'" name="add" tip="删除" @click="removeRow" />
      </template>
      <vxe-grid
        ref="xTableEdit"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        height="300"
        max-height="500"
        align="center"
        size="mini"
        :checkbox-config="{ highlight: true }"
        :radio-config="{ highlight: true }"
        :empty-render="{ name: 'NotData' }"
        :toolbar-config="{ custom: true, size: 'mini' }"
        :row-config="{ isCurrent: true }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="gridOptions.columns"
        :data="gridOptions.data"
      >
        <template #name="{row}">
          <el-input v-model="row.name" placeholder="请输入名称" size="mini" />
        </template>
        <template #value="{row}">
          <el-input v-model="row.value" :disabled="mode === 'edit'" placeholder="请输入成员值" size="mini" />
        </template>
        <template #channel="{row}">
          <!-- <el-input v-model="row.channel" :disabled="mode === 'edit'" placeholder="请输入成员值" size="mini" /> -->
          <el-select v-model="row.channel" size="mini">
            <el-option
              v-for="item in selectDataOptions['A0054']"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </template>
        <template #priceType="{row}">
          <el-select v-model="row.priceType" size="mini" placeholder="请选择价格类型">
            <el-option
              v-for="item in selectDataOptions['A0020']"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </template>
        <template #sequence="{row}">
          <el-input v-model="row.sequence" placeholder="" size="mini" />
        </template>
        <template #status="{row}">
          <el-link
            size="mini"
            :type="row.status ? 'success' : 'danger'"
            effect="dark"
          >
            {{ row.status ? '启用' : '禁用' }}
          </el-link>
        </template>
      </vxe-grid>

    </TableCommon>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'

export default {
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    editRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      rowSeq: 0,
      selectDataOptions: {},
      gridOptions: {
        data: [],
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 40 },
          { field: 'name', title: '计划类型名称', slots: { default: 'name' }},
          { field: 'value', title: '计划类型编码', slots: { default: 'value' }},
          { field: 'channel', title: '渠道类型', slots: { default: 'channel' }},
          { field: 'priceType', title: '价格类型', slots: { default: 'priceType' }},
          { field: 'status', title: '状态', width: 100, slots: { default: 'status' }},
          { field: 'sequence', title: '排序号', width: 100, slots: { default: 'sequence' }}
        ]
      }
    }
  },
  created() {
    this.getSelectDictDataOrigin('A0054')
    this.getSelectDictDataOrigin('A0020')
    if (this.editRows.length) {
      this.gridOptions.data.push(...this.editRows.map(item => {
        return { ...item }
      }))
    } else {
      this.gridOptions.data.push({
        name: '',
        value: '',
        channel: '',
        priceType: '',
        status: 1,
        statusTextView: '启用',
        sequence: ++this.rowSeq
      })
    }
  },
  methods: {
    addRow() {
      this.gridOptions.data.push({
        name: '',
        value: '',
        channel: '',
        priceType: '',
        status: 1,
        statusTextView: '启用',
        sequence: ++this.rowSeq
      })
    },
    removeRow() {
      const checkedList = this.$refs['xTableEdit'].getCheckboxRecords()
      if (!checkedList.length) return

      checkedList.forEach(file => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === file._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    validRows() {
      try {
        if (!this.gridOptions.data.length) {
          throw new Error('请添加要保存的数据！')
        }
        this.gridOptions.data.forEach(item => {
          if (!item.name || !item.value || item.sequence === '' || item.channel === '' || item.priceType === '') {
            throw new Error('请输入完整的信息！')
          }
        })
      } catch (e) {
        this.$message.error(e.message)
        return false
      }

      return this.gridOptions.data
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/components/DictEdit.vue